<template>
  <div>
    <h1>Registrar Concesión</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Concesionario">
                <v-select :options="Object.values(getConcesionarios)" :reduce="country => country.id" v-model="$v.addConcesion.concesionarioId.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.addConcesion.concesionarioId.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Geocerca">
                <v-select label="name" :options="getAllGeofences" v-model="$v.addConcesion.geocerca.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.addConcesion.geocerca.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de Concesión">
                <a-input
                  placeholder="Número de Concesión"
                  v-model="$v.addConcesion.concesionNumber.$model"
                />
                <small class="text-danger" v-if="!$v.addConcesion.concesionNumber.required">Campo requerido. No debe estar vacío.</small>
                <!--<small class="text-danger" v-if="!$v.addConcesion.concesionNumber.numeric">Ingresa un número válido</small>-->
                <small class="text-danger" v-if="!$v.addConcesion.concesionNumber.maxLength">Ingresa un número menor o igual a veinte caracteres</small>
                <small class="text-danger" v-if="!validateRegisteredConcesion($v.addConcesion.concesionNumber.$model)">Ya existe una registro con este número de concesión</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="¿Pertenece a un sitio?">
                <a-checkbox v-model="siteYes" @click="cleanSite()">
                  sitio
                </a-checkbox>
              </a-form-item>
            </div>
            <div v-if="siteYes===true" class="col-md-6">
              <a-form-item label="Sitio">
                <v-select label="name" :options="getAllSites" v-model="$v.addConcesion.siteId.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="!(validateRegisteredConcesion($v.addConcesion.concesionNumber.$model) && !$v.$invalid)"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { required, maxLength } from 'vuelidate/lib/validators'
// import { encrypt } from '@/config/headers'
import headers from '@/config/headers.js'
const GET_CONCESIONES_QUERY = gql`
  query getAllConceciones{
    getAllConceciones{
      id
      concesionNumber
    }
  }
`
const GET_GEOCERCAS = gql`
  query getAllGeofences{
    getAllGeofences{
      id
      name
    }
  }
`
const GET_SITES = gql`
  query getAllSites{
     getAllSites{
      id
      name
    }
  }
`
export default {
  data() {
    return {
      lalito: null,
      error: null,
      siteYes: false,
      disabledButton: false,
      form: this.$form.createForm(this),
      addConcesion: {
        concesionNumber: null,
        concesionarioId: null,
        geocerca: null,
        siteId: '',
      },
      getConcesionarios: {
        id: 0,
        name: '',
      },
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      registeredConcesiones: {},
      getAllGeofences: [],
      getAllSites: [],
      sites: {},
      // getAllConceciones: []
    }
  },
  apollo: {
    getConcesionarios: {
      query: gql`query getConcesionarios{
        getConcesionarios{
            id
            label: name
            }
            }
    `,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
    },
    getAllGeofences: {
      query: GET_GEOCERCAS,
      result({ data }) {
        console.log(data)
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
    getAllSites: {
      query: GET_SITES,
      result({ data }) {
        console.log(data)
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
  },
  methods: {
    async handleSubmit() {
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }
      this.disabledButton = true
      if (this.addConcesion.siteId === null) {
        this.$apollo.mutate({
          mutation: gql`mutation addConcesion($concesionNumber: String, $concesionarioId: Int, $geofenceId: Int, $siteId: Int) {
         addConcesion(concesion: {
          concesionNumber: $concesionNumber
          concesionarioId: $concesionarioId
          geofenceId: $geofenceId
          siteId: $siteId
        }){
          concesionNumber
          concesionarioId
          geofenceId
          siteId
        }
        }`,
          context: headers(),
          variables: {
            concesionNumber: this.addConcesion.concesionNumber,
            concesionarioId: parseInt(this.addConcesion.concesionarioId),
            geofenceId: this.addConcesion.geocerca.id,
            siteId: null,
          },
        })
          .then(res => {
            this.$router.push('/concessions/getConcessions')
          })
          .catch(error => {
            console.log(error)
            this.disabledButton = false
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
          })
      } else {
        this.$apollo.mutate({
          mutation: gql`mutation addConcesion($concesionNumber: String, $concesionarioId: Int, $geofenceId: Int, $siteId: Int) {
         addConcesion(concesion: {
          concesionNumber: $concesionNumber
          concesionarioId: $concesionarioId
          geofenceId: $geofenceId
          siteId: $siteId
        }){
          concesionNumber
          concesionarioId
          geofenceId
          siteId
        }
        }`,
          context: headers(),
          variables: {
            concesionNumber: this.addConcesion.concesionNumber,
            concesionarioId: parseInt(this.addConcesion.concesionarioId),
            geofenceId: this.addConcesion.geocerca.id,
            siteId: parseInt(this.addConcesion.siteId.id),
          },
        })
          .then(res => {
            this.$router.push('/concessions/getConcessions')
          })
          .catch(error => {
            console.log(error)
            this.disabledButton = false
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
          })
      }
    },
    cleanSite() {
      this.addConcesion.siteId = null
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    validateRegisteredConcesion(concesionNumber) {
      if (this.registeredConcesiones[concesionNumber]) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    this.$apollo.query({ query: GET_CONCESIONES_QUERY, context: headers() })
      .then(({ data }) => {
        data.getAllConceciones.forEach(concesion => {
          this.registeredConcesiones[concesion.concesionNumber] = 1
        })
        // console.log(this.registeredConcesiones)
      })
      .catch(error => {
        console.log(error)
      })
  },
  validations: {
    addConcesion: {
      concesionNumber: { required, maxLength: maxLength(20) },
      concesionarioId: { required },
      geocerca: { required },
      siteId: {},
    },
  },
}
</script>

<style>

</style>
